import React, { FC, useEffect } from "react";
import { useFetcher } from "react-router-dom";

import PasswordRecoveryForm, {
  PasswordRecoveryFormValues,
} from "./PasswordRecovery";
import { PasswordRecoveryActionData } from "./PasswordRecovery.action";

interface Props {
  onSuccess?: () => void;
}

const PasswordRecoveryFormContainer: FC<Props> = ({ onSuccess }) => {
  const fetcher = useFetcher<PasswordRecoveryActionData>();

  useEffect(() => {
    if (fetcher.data?.success) {
      onSuccess?.();
    }
  }, [fetcher.data?.success, onSuccess]);

  const onSubmit = (values: PasswordRecoveryFormValues): void => {
    fetcher.submit(
      { ...values },
      {
        action: "/password-recovery",
        method: "post",
      },
    );
  };

  return (
    <PasswordRecoveryForm
      {...{ onSubmit }}
      submitting={fetcher.state === "submitting"}
      serverError={fetcher.data?.errors?.email}
    />
  );
};

export default PasswordRecoveryFormContainer;
